export default function(e, key) {
  var files = e.target.files || e.dataTransfer.files;
  Array.prototype.push.apply(this.selectedProfessions[key].images, files);
  if (!this.selectedProfessions[key].images.length) return;
  this.createImage(this.selectedProfessions[key].images, key);
}
